import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "@/i18n/translations";

export default function MagicLogin({ setIsAuthenticated }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("invalid");
      return;
    }
    (async () => {
      try {
        const response = await axios.post(`${API}/auth/magic-login`, { token });
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        setIsAuthenticated(true);
        navigate(response.data.user.is_admin ? "/admin/dashboard" : "/dashboard");
      } catch (e) {
        setError(e.response?.data?.detail || "expired");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-100">
      <div className="bg-white rounded-lg shadow-2xl p-8 border-4 border-black text-center max-w-md w-full">
        {error ? (
          <>
            <h1 className="text-xl font-bold mb-4 break-words" data-testid="magic-login-error">
              ⚠️ {t("auth.magicLoginError") || "Ссылка недействительна или устарела"}
            </h1>
            <button
              data-testid="magic-login-back-btn"
              onClick={() => navigate("/auth")}
              className="underline text-sm text-gray-600 hover:text-black"
            >
              {t("auth.backToLogin") || "Вернуться ко входу"}
            </button>
          </>
        ) : (
          <h1 className="text-2xl font-bold" data-testid="magic-login-loading">
            🔑 {t("auth.magicLoggingIn") || "Входим..."}
          </h1>
        )}
      </div>
    </div>
  );
}
